import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import "./style.css";
import BackBtn from "../../../shared/backBtn/BackBtn";
import ActionBtn from "@/components/ActionBtn";
import ScreenHeader from "@/components/ScreenHeader";
import { useCallback } from "react";

const QFHeader = ({ data }) => {
  const { t } = useTranslation();
  const { id, medicalOrderId, hospitalRequestId } = useParams();

  const handlePrint = useCallback(() => {
    window.print();
  }, []);

  const handleExportPdf = useCallback(() => {
    document.title = `Quotation-${data?.providerName ?? ""}-${hospitalRequestId}`;
    window.print();
    setTimeout(() => { document.title = "Dashboard"; }, 1000);
  }, [data?.providerName, hospitalRequestId]);

  return (
    <div className="qf-header">
      <div className="">
        <BackBtn
          title={t("back-to-case")}
          to={`/panel/account-manager/medical-requests/${id}/${medicalOrderId}`}
        />
        <ScreenHeader className="bg-transparent m-0" title={t("internal-quotation-review")}
          subtitle={`${t("hospital-bid")} ${data?.providerName} ${t("for-patient")} ${data?.patientName}`}
        />
      </div>
      <div className="qf-header-actions no-print">
        <ActionBtn onApply={handlePrint} title={t("print-bid")} icon="solar:printer-outline" className="qf-action-btn" />
        <ActionBtn onApply={handleExportPdf} title={t("export-pdf")} icon="solar:upload-linear" className="qf-action-btn" />
      </div>
    </div>
  );
};

export default QFHeader;
